import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Icon from '@mui/material/Icon'
import { alpha } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import * as gtag from 'lib/gtag'

const useStyles = makeStyles((theme) => ({
  card: {
    marginLeft: '1px',
    marginRight: '1px',
    marginBottom: '3px',
    width: '340px'
  },
  link: {
    textDecoration: 'inherit',
    color: 'inherit'
  },
  button: {
    zIndex: 10000,
    backgroundColor: alpha('#ffffff', 0.9),
    position: 'absolute',
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
    margin: 'auto',
    display: 'block',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#d5d5d5'
    }
  },
  play: {
    color: theme.palette.primary.main,
    fontSize: '60px',
    position: 'relative',
    top: '9px'
  },
  schedule: {
    height: '20px'
  },
  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  image: {
    padding: theme.spacing(3)
  }
}))

export default function CardLiveStreamBig ({ station, active, linkCard }) {
  const classes = useStyles()

  const logEvent = () => {
    gtag.event('livetv', {
      station: station.livetv
    })
  }

  return (
    <Card className={classes.card}>
      <CardActionArea onClick={logEvent} href={station.livetv} rel='noopener noreferrer' data-ga-category='livetv'>
        <span>
          <CardMedia
            component='img'
            width={292}
            src={station.logo}
            title={station.name + ': ' + station.currentShow}
            alt={station.name}
            className={classes.image}
            style={{ background: station.bgcolor }}
            loading='lazy'
          />
          <div className='swiper-lazy-preloader swiper-lazy-preloader-white' />
        </span>
        {active &&
          <div className={classes.button} aria-label='Abspielen' data-test='play-button'>
            <Icon className={classes.play}>play_arrow</Icon>
          </div>}
        <CardContent>
          <Typography gutterBottom variant='body2' color='textSecondary' className={classes.schedule} component='p'>
            {station.currentSchedule}
          </Typography>
          <Typography variant='body2' component='p' className={classes.title}>
            {station.currentShow}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
